<template>
    <div class="migrol-form__checkbox" :class="ComputedClass">
        <input :id="$id('checkbox')" type="checkbox" :checked="shouldBeChecked" :value="checkboxValue" @change="updateInput" v-bind="$attrs" />
        <label :for="$id('checkbox')">{{label}}<slot></slot></label>
    </div>
</template>

<script>
    export default {
        inheritAttrs: false,
        model: {
            prop: 'value',
            event: 'change'
        },
        props: {
            label: {
            },
            checkboxValue: {
                type: String
            },
            value: {
                default: false
            },
            trueValue: {
                default: true
            },
            falseValue: {
                default: false
            },
            type: {
                type: String,
                default: 'checkbox',
                required: false
            },
            extraCssClass: {
                type: String,
                default: '',
                required: false
            }
        },
        computed: {
            ComputedClass() {
                return 'migrol-form__checkbox--' + this.type + ' ' + this.extraCssClass;
            },
            shouldBeChecked() {
                if (this.value instanceof Array) {
                    return this.value.includes(this.checkboxValue)
                }
                // Note that 'true-value' and 'false-value' are camelCase in the JS
                return this.value === this.trueValue
            }
        },
        methods: {
            updateInput(event) {
                let isChecked = event.target.checked;

                if (this.value instanceof Array) {
                    let newValue = [...this.value];

                    if (isChecked) {
                        newValue.push(this.checkboxValue);
                    } else {
                        newValue.splice(newValue.indexOf(this.checkboxValue), 1);
                    }

                    this.$emit('change', newValue);
                } else {
                    this.$emit('change', isChecked ? this.trueValue : this.falseValue);
                }
            }
        }
    };
</script>